import React, { useState, useContext } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate, useParams } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import { AuthContext } from '../AuthContextProvider';
import * as Constants from '../Constants';
import '../App.css';

const CreateEvent = () => {
  const [name, setName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [description, setDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { type } = useParams();

  const onSuccess = () => {
    navigate('/events');
  };

  const createEvent = async () => {
    if (name === '' || displayName === '' || description === '') {
      setErrorMessage('Name, DisplayName and Description fields are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _site: user._site._id,
      name,
      displayName,
      description,
      type
    };
    rpc({
      method: 'CreateEvent',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <div className="CreateEvent">
      <Typography variant="h6" gutterBottom>
        Create Event of type {Constants.EVENT_NAMES[type]}
      </Typography>
      <TextField className="TextField"
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <TextField className="TextField"
        label="Display Name"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
      />
      <TextField className="TextField"
        label="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <Button className="Button" variant="contained" color="primary" onClick={createEvent}>
        Create
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default CreateEvent;
